import { errorHandle } from 'redux/actions/error';
import apiService from 'shared/services/ApiService';
import axios from 'axios';
import {
  PROCESSING,
  PROCESSING_DONE,
  SET_LIST_TNC,
  SET_DETAIL_TNC,
} from './types';

const { allBillerApiService } = apiService.getInstance();

export const getListTnc = (paginationUrl, paramUrl = '') => dispatch => {
  dispatch({ type: PROCESSING });

  const tncUrl = `tncs?${paginationUrl}${paramUrl}`;
  allBillerApiService
    .get(tncUrl)
    .then(response => {
      if (response.status === 200) {
        const { payload, pagination } = response.data;
        dispatch({
          type: SET_LIST_TNC,
          payload,
          pagination,
        });
      } else {
        dispatch({ type: SET_LIST_TNC, payload: [], pagination: {} });
        errorHandle(response);
      }
    })
    .catch(error => {
      dispatch({ type: SET_LIST_TNC, payload: [], pagination: {} });
      errorHandle(error);
    });
};

export const asyncTncDetail = async id => {
  const tncUrl = `tncs/${id}`;
  let resolve = null;
  try {
    const resTNC = await allBillerApiService.get(tncUrl);
    const { payload } = resTNC.data;
    const resContent = await axios.get(payload.latest_version.content_url);
    resolve = Promise.resolve({
      status: resTNC.status,
      tnc: payload,
      content: resContent.data,
    });
  } catch (error) {
    resolve = Promise.reject(error);
  }
  return resolve;
};

export const getTncDetail = id => dispatch => {
  dispatch({ type: PROCESSING });
  asyncTncDetail(id)
    .then(res => {
      if (res.status === 200) {
        dispatch({
          type: SET_DETAIL_TNC,
          payload: {
            ...res.tnc,
            content: res.content,
          },
        });
      } else {
        throw new Error('FAILURE_TNC_DETAIL');
      }
    })
    .catch(error => {
      dispatch({ type: PROCESSING_DONE, payload: {} });
      errorHandle(error);
    });
};

export const createTnC = (value, callback) => dispatch => {
  dispatch({ type: PROCESSING });
  allBillerApiService
    .post('tncs', value)
    .then(response => {
      if (response.status === 200) {
        const { payload } = response.data;
        dispatch({ type: SET_DETAIL_TNC, payload });
        callback('success');
      }
    })
    .catch(error => {
      callback('failed');
      dispatch({ type: PROCESSING_DONE });
      errorHandle(error);
    });
};

export const asyncUpdateTnC = async (id, value) => {
  const tncUrl = `tncs/${id}`;
  let resolve = null;
  try {
    const resTNC = await allBillerApiService.put(tncUrl, value);
    const { payload } = resTNC.data;
    const resContent = await axios.get(payload.latest_version.content_url);
    resolve = Promise.resolve({
      status: resTNC.status,
      tnc: payload,
      content: resContent.data,
    });
  } catch (error) {
    resolve = Promise.reject(error);
  }
  return resolve;
};

export const updateTnC = (id, value, callback) => dispatch => {
  dispatch({ type: PROCESSING });
  asyncUpdateTnC(id, value)
    .then(res => {
      if (res.status === 200) {
        callback('success');
        dispatch({
          type: SET_DETAIL_TNC,
          payload: {
            ...res.tnc,
            content: res.content,
          },
        });
      } else {
        throw new Error('FAILURE_UPDATE_TNC_DETAIL');
      }
    })
    .catch(error => {
      callback('failed');
      dispatch({ type: PROCESSING_DONE });
      errorHandle(error);
    });
};
